<template>
  <v-app id="app">
    <LeftNavigation />
    <v-content>
      <TopNavigation />

      <router-view></router-view>
    </v-content>

    <Overlay />
    <Snackbar />
  </v-app>
</template>

<script>
import LeftNavigation from "@/components/navigation/LeftNavigation";
import TopNavigation from "@/components/navigation/TopNavigation";
import Overlay from "@/components/Overlay";
import Snackbar from "@/components/Snackbar";

export default {
  components: {
    LeftNavigation,
    TopNavigation,
    Overlay,
    Snackbar
  },
  data() {
    return {};
  },
  mounted() {
    this.openGlobalLoader("...");
    this.$store
      .dispatch("checkAuthentification")
      .then(() => {
        console.log("Logged");
      })
      .finally(() => {
        this.closeGlobalLoader();
      }); // tu by sa malo pockat na promise
  },
  computed: {
    isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    }
  }
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
